/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getIncidentTypeByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const getIncidentTypeByIdPayloadRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetIncidentTypeById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getIncidentTypeByIdIdRegExpTwo)]).optional(),
  "payload": zod.union([zod.number(),zod.string().regex(getIncidentTypeByIdPayloadRegExpTwo)]).optional()
});

export type GetIncidentTypeById = zod.input<typeof GetIncidentTypeById>;
export type GetIncidentTypeByIdOutput = zod.output<typeof GetIncidentTypeById>;
